import { FontTagFormatV8 } from "../formats/v8/template_format";
import "./style.scss";

export type FontTag =
  | "amatic"
  | "codystar"
  | "dancing"
  | "didot"
  | "futurastd"
  | "handlee"
  | "merriweather"
  | "montserrat"
  | "nunito"
  | "oswald"
  | "playfair"
  | "poppins"
  | "poppins_bold"
  | "poppins_medium"
  | "poppins_regular"
  | "satisfy";

export const fontTags: FontTag[] = [
  "amatic",
  "codystar",
  "didot",
  "dancing",
  "futurastd",
  "handlee",
  "merriweather",
  "montserrat",
  "nunito",
  "oswald",
  "playfair",
  "poppins",
  "poppins_bold",
  "poppins_medium",
  "poppins_regular",
  "satisfy",
];

export class UnsupportedFontTagError extends Error {
  constructor(value: string) {
    super(`Unsupported FontTag "${value}"`);
  }
}

export function fontTagToCssClass(fontTag: FontTag): string {
  switch (fontTag) {
    case "amatic":
    case "codystar":
    case "dancing":
    case "didot":
    case "futurastd":
    case "handlee":
    case "merriweather":
    case "montserrat":
    case "nunito":
    case "oswald":
    case "playfair":
    case "poppins":
    case "poppins_bold":
    case "poppins_medium":
    case "poppins_regular":
    case "satisfy":
      return `AgreedFont--${fontTag}`;
    default: {
      const exhaustiveCheck: never = fontTag;
      throw new UnsupportedFontTagError(exhaustiveCheck);
    }
  }
}

export function fontTagToReadableText(fontTag: FontTag): string {
  switch (fontTag) {
    case "amatic":
    case "codystar":
    case "dancing":
    case "didot":
    case "futurastd":
    case "handlee":
    case "merriweather":
    case "montserrat":
    case "nunito":
    case "oswald":
    case "playfair":
    case "poppins":
    case "satisfy":
      return fontTag;
    case "poppins_bold":
      return "poppins bold";
    case "poppins_medium":
      return "poppins medium";
    case "poppins_regular":
      return "poppins";
    default: {
      const exhaustiveCheck: never = fontTag;
      throw new UnsupportedFontTagError(exhaustiveCheck);
    }
  }
}

export function convertFontTagFromFormat(fontTag: FontTagFormatV8): FontTag {
  switch (fontTag) {
    case "amatic":
    case "codystar":
    case "dancing":
    case "didot":
    case "futurastd":
    case "handlee":
    case "merriweather":
    case "montserrat":
    case "nunito":
    case "oswald":
    case "playfair":
    case "poppins":
    case "poppins_bold":
    case "poppins_regular":
    case "poppins_medium":
    case "satisfy":
      return fontTag;
    default: {
      const exhaustiveCheck: never = fontTag;
      throw new UnsupportedFontTagError(exhaustiveCheck);
    }
  }
}
